import React from 'react'
import CancelModal from './cancelmodal'
import WPEMigReadinessModal from './wpemigreadinessmodal'
import createReactClass from 'create-react-class'

// NOTE:
// Be careful when passing callback functions to modals. Since Reducer converts everthing to Immutable,
// calling a function directly won't work. In order to call a function within modal do:
// this.props.function.toJS()
const ModalController = createReactClass({
	render() {
		let currentmodal = this.props.modals.first()
		if (!currentmodal) {
			return <span></span>
		} else {
			let actions = this.props.actions
			return <span>
				{(() => {
					switch (currentmodal.get('name')) {
					case "CancelModal":   return <CancelModal
						actions={actions}
						gid={currentmodal.get('gid')}
						migrate={currentmodal.get('migrate')}
					/>
					case "WPEMigReadinessModal": return <WPEMigReadinessModal
						actions={actions}
						history={currentmodal.get('history')}
						migrate={currentmodal.get('migrate')}
					/>
					default: return ""
					}
				})()}
			</span>
		}
	}
})

export default ModalController
